import { ServiceStoreConfig } from "../types/ServiceStoreTypes";

/**
 * System Module Service Stores
 */
export const systemStores: ServiceStoreConfig[] = [
  // {
  //   name: "api-services",
  //   options: {
  //     enableStorage: false,
  //     enableErrorNotifications: true,
  //     serviceView: {
  //       enableServiceView: true,
  //       actions: {
  //         enableInlineEdit: true,
  //         enableRemove: true,
  //       },
  //       summaryCards: (rootStore) => {
  //         const store = rootStore.apiServicesStore as { entities?: unknown[] };
  //         const entities = store?.entities || [];
  //         const totalServices = entities.length;
  //         const activeServices = entities.filter(
  //           (service: Record<string, unknown>) =>
  //             service.status === "active" || service.isActive !== false
  //         ).length;
  //         const healthyServices = entities.filter(
  //           (service: Record<string, unknown>) =>
  //             service.health === "healthy" || service.status === "up"
  //         ).length;
  //         const degradedServices = entities.filter(
  //           (service: Record<string, unknown>) =>
  //             service.health === "degraded" || service.status === "degraded"
  //         ).length;
  //         return [
  //           {
  //             title: "Total Services",
  //             value: () => totalServices.toString(),
  //             valueColor: "primary.main",
  //           },
  //           {
  //             title: "Active",
  //             value: () => activeServices.toString(),
  //             valueColor: "success.main",
  //           },
  //           {
  //             title: "Healthy",
  //             value: () => healthyServices.toString(),
  //             valueColor: "success.main",
  //           },
  //           {
  //             title: "Degraded",
  //             value: () => degradedServices.toString(),
  //             valueColor: "warning.main",
  //           },
  //         ];
  //       },
  //       permissions: {
  //         requiresAuth: true,
  //         requiresAdmin: true,
  //       },
  //     },
  //   },
  // },
  // {
  //   name: "notifications",
  //   options: {
  //     enableStorage: false, // Real-time notifications should not be cached
  //     enableErrorNotifications: true,
  //     idField: "notificationId",
  //     serviceView: {
  //       enableServiceView: true,
  //       actions: {
  //         enableInlineEdit: true,
  //         enableRemove: true,
  //       },
  //       summaryCards: (rootStore) => {
  //         const store = rootStore.notificationsStore as {
  //           entities?: unknown[];
  //         };
  //         const entities = store?.entities || [];
  //         const totalNotifications = entities.length;
  //         const unreadNotifications = entities.filter(
  //           (notification: Record<string, unknown>) =>
  //             !notification.isRead && notification.status !== "read"
  //         ).length;
  //         const urgentNotifications = entities.filter(
  //           (notification: Record<string, unknown>) =>
  //             notification.priority === "urgent" ||
  //             notification.priority === "high"
  //         ).length;
  //         const todayNotifications = entities.filter(
  //           (notification: Record<string, unknown>) => {
  //             const notifDate = new Date(notification.createdAt as string);
  //             const today = new Date();
  //             today.setHours(0, 0, 0, 0);
  //             return notifDate >= today;
  //           }
  //         ).length;
  //         return [
  //           {
  //             title: "Total Notifications",
  //             value: () => totalNotifications.toString(),
  //             valueColor: "primary.main",
  //           },
  //           {
  //             title: "Unread",
  //             value: () => unreadNotifications.toString(),
  //             valueColor: "warning.main",
  //           },
  //           {
  //             title: "Urgent",
  //             value: () => urgentNotifications.toString(),
  //             valueColor: "error.main",
  //           },
  //           {
  //             title: "Today",
  //             value: () => todayNotifications.toString(),
  //             valueColor: "info.main",
  //           },
  //         ];
  //       },
  //       permissions: {
  //         requiresAuth: true,
  //         requiresAdmin: false,
  //       },
  //       defaultSort: {
  //         sortBy: ["createdAt"],
  //         sortDirection: { createdAt: "DESC" },
  //       },
  //     },
  //   },
  // },
];
